export class ConstructorParams {

    build(target: any) {
        let args = [];

        for (let arg of Reflect.getMetadata('design:paramtypes', target)) {
            args.push(new arg());
        }

        return args;
    }

}
